/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */


import React, {Component} from 'react';
import {Draggable} from 'react-beautiful-dnd';
import TableBody from "./TableBody";
import DropDown from '../../../../widgets/DropDown/DropDown';
import PropTypes from "prop-types";
import Svg from '../../../../widgets/Svg/Svg';
import UserPermissionSingleton from '../../../../../_helpers/UserPermissionSingleton';
import {PERMISSIONS} from '../../../../../constants/APP_CONSTANTS';


export default class Table extends Component {
    static get propTypes() {
        return {
            chapterId: PropTypes.string.isRequired,
            collectionId: PropTypes.string.isRequired,
            removePart: PropTypes.func.isRequired,
            chapterCount: PropTypes.number.isRequired,
            freezeUi: PropTypes.func.isRequired,
            updateTitle: PropTypes.func.isRequired,
            collectionType: PropTypes.string.isRequired,
            createPart:PropTypes.func.isRequired,
            activeCollection: PropTypes.object.isRequired,
            uploadFile: PropTypes.func.isRequired,
            resourceUploadData: PropTypes.object.isRequired,
            resourceUploadSuccessDataEdit: PropTypes.func.isRequired,
            updateAdditionalResourceInfo: PropTypes.func.isRequired,
            uploadContent: PropTypes.func.isRequired,
            clearAdditionalInfo: PropTypes.func.isRequired,
            closeModal: PropTypes.func.isRequired,
            getResource: PropTypes.func.isRequired,
            clearResource: PropTypes.func.isRequired
        };
    }

    constructor(props) {
        super(props);
        const newTitle = this.getTitleName(this.props.title);
        this.state = {
            titleEdit: false,
            titleValue: newTitle
        };
        this.uploadContent = this.uploadContent.bind(this);
    }

    getTitleName = (titleWithIndex) => {
        const title = titleWithIndex.slice(0, -2);
        return title;
    };
    deletePart = (removeResources) => {
        this.props.removePart(this.props.collectionId, this.props.chapterId, removeResources);
        this.props.freezeUi(true);

    };
    getChapterMenuOptions = () => {
        return (
            {
                toggle: <Svg svgString="delete-18"/>,
                menuAlign: 'right',
                upwards: true,
                align: 'left',
                items: this.props.chapterCount !== 1 ? [
                    <button onClick={() => {
                        this.deletePart(false);
                    }}>Delete This Part</button>,
                    <button onClick={() => {
                        this.deletePart(true);
                    }}>Delete This Part And Content</button>
                ] : [
                    <button onClick={() => {
                        this.deletePart(true);
                    }}>Delete This Part And Content</button>
                ]
            }
        );
    };

    updateTableTitle = () => {
        const payload = {"chapterId": this.props.chapterId, "title": this.state.titleValue};
        this.props.updateTitle(this.props.collectionId, this.props.chapterId, payload);
        this.setState({titleEdit: false});
    };

    uploadContent(chapterId) {
        const activeCollection = this.props.activeCollection;

        let totalPrice = 0;

        if (activeCollection) {
            let title = activeCollection.title;

            const priceModel = activeCollection.priceModel;

            if (priceModel) {
                totalPrice = priceModel.totalPrice;
            }

            const init = {
                activeCollection: activeCollection,
                chapterId: chapterId,
                collectionTitle: title,
                currency: activeCollection.geo.code,
                insertAfter: 0,
                priceType: activeCollection.collectionType,
                resourceIds: this.props.resourceIds,
                totalPrice: totalPrice
            };

            this.props.uploadContent(init);
        }
    }
    render() {

        const resourceIns = this.props.resourceIns.resourceData;
        const index = this.props.index;
        const { deleteInstance, title, createPart, chapterId, collectionId, freezeUi, showAddContentComponent, showAddOM3PComponent,
            activeCollection, uploadFile, resourceUploadData, updateAdditionalResourceInfo, resourceUploadSuccessDataEdit,
            clearAdditionalInfo, closeModal, getResource, clearResource } = this.props;

        return (
            <Draggable draggableId={this.props.title} index={index} isDragDisabled={UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_table_draggable)}>
                {(provided) => (
                    
                    <div className='component-dnd-table'>
                        <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                        >
                            <div className="table-row">
                                <div className='section-break'>
                                    <span>Would you like to add the section header as a page divider to your book? </span>
                                    {
                                        this.props.collectionType === 'Digital' ?
                                            <span><input type="checkbox" id="check" disabled/>Yes</span>
                                            : <span><input type="checkbox" id="check"/>Yes</span>
                                    }

                                </div>

                            </div>
                            <div className="table-header">
                                <div className='index cell'></div>
                                {!this.state.titleEdit && <div className="col-3 cell" onClick={() => {
                                    UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_part_title) ? 
                                        this.setState({titleEdit: false}) : this.setState({titleEdit: true});
                                }} {...provided.dragHandleProps}
                                >
                                    {this.state.titleValue}
                                </div>}
                                {this.state.titleEdit && <div className="col-3 cell"  {...provided.dragHandleProps}
                                >
                                    <input value={this.state.titleValue} onBlur={this.updateTableTitle}
                                        onChange={(e) => {this.setState({titleValue: e.target.value});}}>
                                    </input>
                                </div>}
                                <div className="col-3 cell" {...provided.dragHandleProps}
                                >
                                    File Name
                                </div>
                                <div className="col-3-5 cell" {...provided.dragHandleProps}
                                >
                                    Author
                                </div>
                                <div className="col-1-5 cell" {...provided.dragHandleProps}
                                >
                                    Identifier Type
                                </div>
                                <div className="col-2 cell" {...provided.dragHandleProps}
                                >
                                    ISBN
                                </div>
                                <div className="col-1 cell" {...provided.dragHandleProps}
                                >
                                    Price
                                </div>

                                <div className="col-icons cell"
                                >
                                    <div className='edit-icons'>
                                        {(resourceIns.length > 0 && !UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_delete_part)) ? <DropDown {...this.getChapterMenuOptions()} className="part-drop-down"></DropDown> :                                 <span>
                                            <span></span><Svg svgString={'delete-18'} style={{fill: 'lightGrey'}}></Svg></span>}
                                    </div>
                                </div>

                            </div>
                            <TableBody
                                deleteInstance={deleteInstance}
                                listId={title}
                                resourceIns={resourceIns}
                                createPart={createPart}
                                chapterId={chapterId}
                                collectionId={collectionId}
                                freezeUi={freezeUi}
                                showAddContentComponent = {showAddContentComponent}
                                showAddOM3PComponent = {showAddOM3PComponent}
                                activeCollection={activeCollection}
                                uploadFile={uploadFile}
                                resourceUploadData={resourceUploadData}
                                updateAdditionalResourceInfo={updateAdditionalResourceInfo}
                                resourceUploadSuccessDataEdit={resourceUploadSuccessDataEdit}
                                uploadContent={this.uploadContent}
                                clearAdditionalInfo={clearAdditionalInfo}
                                closeModal={closeModal}
                                getResource={getResource}
                                clearResource={clearResource}
                            />
                        </div>
                    </div>
                )}

            </Draggable>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/ComponentPageComponents/ChapterComponents/Table.js